import { render, staticRenderFns } from "./unionpay-balance.vue?vue&type=template&id=5bf5c9f6&scoped=true&"
import script from "./unionpay-balance.vue?vue&type=script&lang=js&"
export * from "./unionpay-balance.vue?vue&type=script&lang=js&"
import style0 from "./unionpay-balance.vue?vue&type=style&index=0&id=5bf5c9f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf5c9f6",
  null
  
)

export default component.exports